<app-card-container
  [title]="'Flexible Methods of Learning'"
  [cardType]="cardTypeSlugs.FLEXIBLE_METHODS_OF_LEARNING"
  [description]="
    'Retake any training at no additional cost during the year of an active subscription.'
  "
  [containerBackgroundCss]="'flexible-methods-learning-background'">
  <!--NOTE: Pass in custom cards into the card container ngcontent-->
  <div class="tile-layout-{{ flexibleMethodsLearningList.length }}" #cardContainer>
    <!--FLEXIBLE METHODS OF LEARNING LIST-->
    <ng-container *ngIf="flexibleMethodsLearningList">
      <app-card
        *ngFor="
          let learningItem of flexibleMethodsLearningList;
          let i = index;
          trackBy: trackByLearningItem
        "
        [icon]="[learningItem.icon, 'large', 'red']"
        [cardType]="cardType.FLEXIBLE_METHODS_OF_LEARNING"
        [customHeaderCss]="'flexible-methods-learning'"
        [customCardHeightCss]="'card-min-height'"
        [customHeaderTitleCss]="[
          'text-align-center',
          'wrapped-text-height',
          'auto-margin-center',
          'large-text-no-margin',
          'bold'
        ]"
        [title]="learningItem.name"
        [description]="learningItem.description"
        [showButton]="false">
      </app-card>
    </ng-container>
    <!--END FLEXIBLE METHODS OF LEARNING LIST-->
  </div>
</app-card-container>
